<template>
  <div>
    <bd-upload
      class="avatar-uploader"
      v-bind="$attrs"
      :action="action"
      :disabled="readonly || disabled"
      :multiple="false"
      :show-file-list="false"
      :accept="fileType"
      :before-upload="beforeAvatarUpload"
      :with-credentials="true"
      :on-success="handleSuccess"
    >
      <div v-if="imgUrl" class="bd-upload-list--picture-card">
        <img :src="imgUrl" class="avatar" />
        <span class="bd-upload-list__item-actions">
          <span class="bd-upload-list__item-preview" @click.stop="handlePictureCardPreview">
            <GeneralIconZoomIn :size="18"></GeneralIconZoomIn>
          </span>
          <span v-if="!disabled" class="bd-upload-list__item-delete" @click.stop="handleRemove">
            <GeneralIconDelete :size="18"></GeneralIconDelete>
          </span>
        </span>
      </div>
      <div v-else class="avatar-uploader-icon">
        <GeneralIconPlus :size="24" class="mb12 c-deep-black"></GeneralIconPlus>
        <div class="font-size-14 font-weight-400 line-height-1 c-333">上传图片</div>
      </div>
    </bd-upload>
    <bd-dialog v-model="dialogVisible">
      <img width="100%" :src="imgUrl" alt="" />
    </bd-dialog>
  </div>
</template>

<script>
import { GeneralIconZoomIn, GeneralIconDelete, GeneralIconPlus } from '@bilibili-business/icons-vue-plus'

// 上传单张图片,以后有需求再扩充成多张
const COMPONENT_NAME = 'el-upload-img'
export default {
  emits: ['input'],
  name: COMPONENT_NAME,
  components: { GeneralIconZoomIn, GeneralIconDelete, GeneralIconPlus },
  props: {
    action: {
      require: true,
      type: String
    },
    // imgUrl
    value: {
      require: true,
      type: String
    },
    // 单位:kb
    maxSize: {
      type: Number,
      default() {
        return 300
      }
    },
    disabled: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      imgUrl: '',
      fileType: 'image/png,image/jpeg,image/jpg',
      dialogVisible: false,
      readonly: false
    }
  },
  watch: {
    value(n) {
      this.imgUrl = n
    }
  },
  methods: {
    handleSuccess(file) {
      if (!file.result) return
      const { image_url: url } = file.result
      this.imgUrl = url
      this.readonly = true
      this.$emit('input', this.imgUrl)
    },
    async beforeAvatarUpload(file) {
      let isSuccess = false
      try {
        await this.handleMaxSize(file)
        await this.handleDimension(file)
        isSuccess = true
        // eslint-disable-next-line no-empty
      } catch (e) {}
      return isSuccess
    },
    handleMaxSize(file) {
      return new Promise((resolve, reject) => {
        if ((file.size / 1024).toFixed(2) > this.maxSize) {
          this.$message.error('图片' + file.name + '太大，不能超过' + this.maxSize + 'kb。')
          reject()
        } else {
          resolve()
        }
      })
    },
    handleDimension(file) {
      let width = 0
      let height = 0
      new Promise(resolve => {
        let _URL = window.URL || window.webkitURL
        const img = new Image()
        img.onload = () => {
          width = img.width
          height = img.height
          resolve()
        }
        img.src = _URL.createObjectURL(file)
      }).then(() => {
        if (width === 400 && height === 400) {
          return Promise.resolve()
        } else {
          this.$message.error('上传图片像素要等于400 * 400!')
          return Promise.reject()
        }
      })
    },
    handleRemove() {
      this.imgUrl = ''
      this.readonly = false
      this.$emit('input', this.imgUrl)
    },
    handlePictureCardPreview() {
      this.dialogVisible = true
    }
  }
}
</script>

<style lang="less">
.avatar-uploader {
  display: flex;
  cursor: pointer;
  .bd-upload {
    border: 1px dashed #e6e6e6;
    border-radius: 4px;
    position: relative;
    overflow: hidden;
    width: 120px;
    height: 120px;
    line-height: 1;
    &:hover {
      border-color: #ff6699;
    }
    .bd-upload-list {
      line-height: 0;
      .bd-upload-list__item-actions {
        width: 80px;
        height: 80px;
      }
      .bd-upload-list__item {
        width: 80px;
        height: 80px;
        border: none;
        background-color: #fafafa;
        .bd-upload-list__item-status-label {
          display: none;
        }
        .bd-upload-list__item-actions {
          font-size: 16px;
          .bd-upload-list__item-preview {
            margin-right: 12px;
          }
          .bd-upload-list__item-delete {
            margin-left: 0px;
          }
          .bd-upload-list__item-download {
            margin-left: 0px;
            display: none;
          }
        }
      }
      .file-slot {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          margin-top: 12px;
          width: 26px;
        }
        .file-slot-file-name {
          margin-top: 8px;
          width: 59px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: #333;
          text-align: center;
          font-family: PingFang SC;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 18px;
        }
      }
    }
    .bd-upload--picture-card {
      position: relative;
      margin: 0px 8px 8px 0px;
      width: 80px;
      height: 80px;
      background: transparent;
    }
    &.hide-uploader {
      .upload {
        display: none;
      }
    }
  }
  .avatar-uploader-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .avatar {
    width: 120px;
    height: 120px;
    display: block;
    background-size: contain;
  }
}
</style>
